import { render, staticRenderFns } from "./HistoricalDataReport.vue?vue&type=template&id=ea3f7112&"
import script from "./HistoricalDataReport.vue?vue&type=script&lang=js&"
export * from "./HistoricalDataReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports